import reactComponentLoader from 'scripts/react-component-loader'

import { Sidebar } from '.'

reactComponentLoader(Sidebar, '[data-user-sidebar]')
